import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  overflow-y: auto;
  form {
    width: 100%;
    margin: 2rem;
  }
`

export const ButtonContainer = styled.div`
  button {
    display: flex;
    text-transform: uppercase;
    margin: auto;
    width: 80px;
    &:disabled {
      color: rgba(0, 0, 0, 0.65);
      cursor: not-allowed;
      background: rgba(0, 0, 0, 0.05);
    }
  }
`

export const SectionBlock = styled.section`
  display: inline-block;
  flex-direction: column;
  margin: 2em 8px 8px 8px;
  width: 100%;
  border-top: 1px solid var(--foreground);

  > label {
    position: relative;
    left: 5%;
    top: -10px;
    background-color: var(--background);
    font-weight: bold;
    padding: 8px;
  }
`

export const FormFieldBlock = styled.div`
  display: flex;
  flex-direction: column;
  margin: 8px;
  width: 100%;

  > div {
    display: flex;
    flex-direction: row;
    width: 100%;
  }

  input,
  select {
    color: #0e76eb;
    width: 100%;
    border: 1px solid rgba(176, 180, 186, 0.42);
    border-radius: 4px;
    transition: all 0.2s ease;
    background-color: transparent;
    font-size: 14px;
    outline: none;
    resize: none;
    overflow: hidden;
    text-align: left;
    &:disabled {
      cursor: not-allowed;
      color: rgba(0, 0, 0, 0.65);
      background: rgba(0, 0, 0, 0.05);
    }
    &[type='checkbox'] {
      cursor: pointer;
      width: auto;
      min-height: 14px;
      padding: 0;
    }
  }
  .ant-select-selector {
    padding: 0 !important;
    color: rgba(0, 0, 0, 0.65) !important;
  }
  .ant-select {
    width: 70%;
  }
  .ant-select-selection-item {
    color: #0e76eb;
  }
`

export const FormFieldGroup = styled.div`
  display: flex;
  flex-basis: 70%;
  align-items: center;

  input,
  select {
    margin-left: 8px;
    &:first-child {
      margin-left: 0;
    }
  }
`

export const FormFieldLabel = styled.label`
  width: 25%;
  font-weight: bold;
  display: flex;
  align-items: center;
  color: rgba(0, 0, 0, 0.65);
`

export const FormErrorMessage = styled.div`
  width: 100%;
  display: flex;
  color: #f00;
  justify-content: flex-end;
`
